import {
	formatUtcMonthDay,
	formatUtcWeekRange,
} from "@productlane/lib/src/reporting/bucket-range"

// Reporting buckets arrive as the ISO date of the Monday the week starts on.
export const formatWeekLabel = (bucket: string) =>
	formatUtcMonthDay(new Date(`${bucket}T00:00:00.000Z`))

// PostHog labels a daily bucket with a calendar date, sometimes carrying a time
// and an offset. Only the date it named matters, so the rest never reaches Date.
const parseDay = (date: string) =>
	new Date(`${date.slice(0, 10)}T00:00:00.000Z`)

export const formatDayTick = (date: string) => formatUtcMonthDay(parseDay(date))

export const formatDayLabel = (date: string) => {
	const day = parseDay(date)
	return `${formatUtcMonthDay(day)}, ${day.getUTCFullYear()}`
}

export const formatWeekRangeLabel = (bucket: string) =>
	formatUtcWeekRange(new Date(`${bucket}T00:00:00.000Z`))
